/* eslint-disable prettier/prettier */
import {
  EppsCustomField,
  SchemaAndRules,
  YupIScreenGroupScreens,
} from '@frontend/pricing-search';
import { randomUUID } from '@frontend/utils';
import { cloneDeep } from 'lodash';

export const mapCustomFieldsToSchema = (
  fields: EppsCustomField[],
  NSSampleSchema: SchemaAndRules,
) => {
  const sampleSchemaCopy = cloneDeep(NSSampleSchema);
  const indexOfScreenGroup = sampleSchemaCopy.schema.screens.findIndex(
    (screen) => screen.type === 'screen_group',
  );
  const indexOfGeneralLoanInformation = sampleSchemaCopy.schema.screens
    .filter((screen) => screen.type === 'screen_group')
    .findIndex((screen) =>
      screen.screens.find(
        (s) => s.id === 'c8fc0171-c0c4-46fd-b81e-0c2e315512e2',
      ),
    );
  if (indexOfGeneralLoanInformation === -1) return sampleSchemaCopy;
  const customFieldsSection = {
    id: randomUUID(),
    type: 'screen',
    name: 'Custom Fields',
    fields: [
      {
        type: 'field_group',
        name: 'VISIBLE',
        fields: [...fields],
      },
    ],
  };
  // insert custom fields section into the schema
  (sampleSchemaCopy.schema.screens as YupIScreenGroupScreens)[
    indexOfScreenGroup
  ].screens.splice(indexOfGeneralLoanInformation + 1, 0, {
    id: customFieldsSection.id,
  });
  sampleSchemaCopy.schema.screens.push(customFieldsSection);
  return sampleSchemaCopy;
};
